var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionDateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 45,
    rx: 4,
    fill: "#DBF3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4688_2035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1343 9.73242H33.744V13.8788C33.744 14.5837 33.205 15.1226 32.5002 15.1226C31.7953 15.1226 31.2563 14.5836 31.2563 13.8788V9.73242H17.1586V13.8788C17.1586 14.5837 16.6196 15.1226 15.9148 15.1226C15.2099 15.1226 14.6709 14.5836 14.6709 13.8788V9.73242H8.86594C8.16103 9.73242 7.62207 10.2715 7.62207 10.9763V18.8543H40.3782V10.9764C40.3781 10.2715 39.8392 9.73242 39.1343 9.73242Z",
    fill: "#D4E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62207 38.7565C7.62207 39.4614 8.16111 40.0004 8.86594 40.0004H39.1343C39.8392 40.0004 40.3781 39.4614 40.3781 38.7565V18.4395H7.62207V38.7565Z",
    fill: "#4DCFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9148 15.122C16.6198 15.122 17.1587 14.5829 17.1587 13.8781V9.73168V7.24387C17.1587 6.53904 16.6197 6 15.9148 6C15.21 6 14.6709 6.53904 14.6709 7.24387V9.73168V13.878C14.6709 14.5829 15.2099 15.122 15.9148 15.122Z",
    fill: "#3A2C51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 15.122C33.2051 15.122 33.7441 14.5829 33.7441 13.8781V9.73168V7.24387C33.7442 6.53904 33.2051 6 32.5002 6C31.7953 6 31.2563 6.53904 31.2563 7.24387V9.73168V13.878C31.2563 14.5829 31.7953 15.122 32.5002 15.122Z",
    fill: "#3A2C51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6462 33.3647H28.7682C29.4731 33.3647 30.012 32.8256 30.012 32.1208C30.012 31.416 29.473 30.877 28.7682 30.877H19.6462C18.9413 30.877 18.4023 31.416 18.4023 32.1208C18.4023 32.8256 18.9413 33.3647 19.6462 33.3647Z",
    fill: "#00BBD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6462 27.56H28.7682C29.4731 27.56 30.012 27.021 30.012 26.3161C30.012 25.6112 29.473 25.0723 28.7682 25.0723H19.6462C18.9413 25.0723 18.4023 25.6113 18.4023 26.3161C18.4023 27.021 18.9413 27.56 19.6462 27.56Z",
    fill: "#00BBD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4688_2035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionDateIcon);
export default __webpack_public_path__ + "static/media/SessionDateIcon.12b9478d47e4c77297d3b7a75be36042.svg";
export { ForwardRef as ReactComponent };